// This exists so we can have an easier time stubbing it out in tests.
export default Math;
